import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CountdownModule } from 'ngx-countdown';

import { ComponentsModule } from '../core/components/component.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ListagemAgendamentoComponent } from './agendamento/listagem-agendamento/listagem-agendamento.component';
import { CadastroFuncionarioComponent } from './funcionario/cadastro-funcionario/cadastro-funcionario.component';
import { ListagemFuncionarioComponent } from './funcionario/listagem-funcionario/listagem-funcionario.component';
import { ListagemCaixaComponent } from './caixa/listagem-caixa/listagem-caixa.component';
import { RelatorioPlacasCaixaComponent } from './relatorios/relatorio-placas-caixa/relatorio-placas-caixa.component';
import { RelatorioClientesCaixaComponent } from './relatorios/relatorio-clientes-caixa/relatorio-clientes-caixa.component';
import { RelatorioVendasPorProdutoComponent } from './relatorios/relatorio-vendas-por-produto/relatorio-vendas-por-produto.component';
import { ModalAberturaCaixaComponent } from './caixa/modal-abertura-caixa/modal-abertura-caixa.component';
import { ModalAcessoRestritoCaixaComponent } from './caixa/modal-acesso-restrito-caixa/modal-acesso-restrito-caixa.component';
import { ModalRelatoriosMensaisCaixaComponent } from './caixa/modal-relatorios-mensais-caixa/modal-relatorios-mensais-caixa.component';
import { ModalSangriaCaixaComponent } from './caixa/modal-sangria-caixa/modal-sangria-caixa.component';
import { ModalSuprimentosCaixaComponent } from './caixa/modal-suprimentos-caixa/modal-suprimentos-caixa.component';
import { CadastroDesengateComponent } from './desengate/cadastro-desengate/cadastro-desengate.component';
import { ListagemDesengatesComponent } from './desengate/listagem-desengates/listagem-desengates.component';
import { ListagemEmpresaComponent } from './empresa/listagem-empresa/listagem-empresa.component';
import { TransferenciaEmpresaComponent } from './empresa/transferencia-empresa/transferencia-empresa.component';
import { CadastroEngateComponent } from './engate/cadastro-engate/cadastro-engate.component';
import { ListagemEngatesComponent } from './engate/listagem-engates/listagem-engates.component';
import { CadastroEntradaComponent } from './entrada-gate/cadastro-entrada/cadastro-entrada.component';
import { ListagemEntradaGateComponent } from './entrada-gate/listagem-entrada-gate/listagem-entrada-gate.component';
import { ModalAlteracaoEntradaComponent } from './entrada-gate/modal-alteracao-entrada/modal-alteracao-entrada.component';
import { CadastroEntradaEstacionamentoTpgComponent } from './estacionamento-tpg/cadastro-entrada-estacionamento-tpg/cadastro-entrada-estacionamento-tpg.component';
import { CadastroSaidaEstacionamentoTpgComponent } from './estacionamento-tpg/cadastro-saida-estacionamento-tpg/cadastro-saida-estacionamento-tpg.component';
import { ListagemEstacionamentoTpgComponent } from './estacionamento-tpg/listagem-estacionamento-tpg/listagem-estacionamento-tpg.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { ListagemParametrizacaoComponent } from './parametrizacao/patio/listagem-parametrizacao/listagem-parametrizacao.component';
import { CadastroServicoComponent } from './parametrizacao/servicos/cadastro-servico/cadastro-servico.component';
import { ListagemServicoComponent } from './parametrizacao/servicos/listagem-servico/listagem-servico.component';
import { EmailSenhaComponent } from './recuperar-senha/email-senha/email-senha.component';
import { EsqueciSenhaComponent } from './recuperar-senha/esqueci-senha/esqueci-senha.component';
import { CadastroSaidaGateComponent } from './saida-gate/cadastro-saida-gate/cadastro-saida-gate.component';
import { ListagemSaidaGateComponent } from './saida-gate/listagem-saida-gate/listagem-saida-gate.component';
import { ModalAcessoRestritoComponent } from './saida-gate/modal-acesso-restrito/modal-acesso-restrito.component';
import { ModalEmpresasFaturadasComponent } from './saida-gate/modal-empresas-faturadas/modal-empresas-faturadas.component';
import { ModalPagamentoSaidaComponent } from './saida-gate/modal-pagamento-saida/modal-pagamento-saida.component';
import { CadastroEntradaServicosComponent } from './servicos/cadastro-entrada-servicos/cadastro-entrada-servicos.component';
import { ListagemServicosComponent } from './servicos/listagem-servicos/listagem-servicos.component';
import { CadastroLaudoHigienizacaoComponent } from './laudo-higienizacao/cadastro-laudo-higienizacao/cadastro-laudo-higienizacao.component';
import { ListagemLaudosHigienizacaoComponent } from './laudo-higienizacao/listagem-laudos-higienizacao/listagem-laudos-higienizacao.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { CadastroPrecificacaoComponent } from './parametrizacao/precificacao/cadastro-precificacao/cadastro-precificacao.component';
import { ListagemPrecificacaoComponent } from './parametrizacao/precificacao/listagem-precificacao/listagem-precificacao.component';
import { ModalFechamentoCaixaComponent } from './caixa/modal-fechamento-caixa/modal-fechamento-caixa.component';
import { ModalPagamentoCaixaComponent } from './caixa/modal-pagamento-caixa/modal-pagamento-caixa.component';
import { CadastroParametrizacaoAcessosComponent } from './gestao-acesso/cadastro-parametrizacao-acessos/cadastro-parametrizacao-acessos.component';
import { ModalCadastrarPerfilComponent } from './gestao-acesso/modal-cadastrar-perfil/modal-cadastrar-perfil.component';
import { ListagemOrdemServicoComponent } from './empresa/listagem-ordem-servico/listagem-ordem-servico.component';
import { ListagemLogsComponent } from './logs/listagem-logs/listagem-logs.component';
import { ModalSelecaoDesengateComponent } from './engate/modal-selecao-desengate/modal-selecao-desengate.component';
import { CadastroHigienizacaoAgendadaComponent } from './higienizacao-agendada/cadastro-higienizacao-agendada/cadastro-higienizacao-agendada.component';
import { ListagemHigienizacaoAgendadaComponent } from './higienizacao-agendada/listagem-higienizacao-agendada/listagem-higienizacao-agendada.component';
import { CadastroAgendamentoComponent } from './agendamento/cadastro-agendamento/cadastro-agendamento.component';
import { ModalAutorizacaoComponent } from './engate/modal-autorizacao/modal-autorizacao.component';
import { ListagemMotoristasComponent } from './motoristas/listagem-motoristas/listagem-motoristas.component';
import { VisualizacaoMotoristaComponent } from './motoristas/visualizacao-motorista/visualizacao-motorista.component';
import { ModalVincularCavaloCarretaComponent } from './empresa/modal-vincular-cavalo-carreta/modal-vincular-cavalo-carreta.component';
import { IconsModule } from '../shared/icons.module';
import { ListagemBlacklistComponent } from './parametrizacao/blacklist/listagem-blacklist/listagem-blacklist.component';
import { FormBlacklistComponent } from './parametrizacao/blacklist/form-blacklist/form-blacklist.component';
import { ListagemTransportadoraComponent } from './transportadora/listagem-transportadora/listagem-transportadora.component';
import { CadastroTransportadoraComponent } from './transportadora/cadastro-transportadora/cadastro-transportadora.component';
import { PatioFormModalComponent } from './parametrizacao/patio/patio-form-modal/patio-form-modal.component';
import { TipoTurnoPipe } from '../core/pipes/tipo-turno.pipe';
import { MatTooltip } from "@angular/material/tooltip";
import { MatTooltipModule  } from "@angular/material/tooltip";
import { QuantidadeVeiculosPatioComponent } from './relatorios/quantidade-veiculos-patio/quantidade-veiculos-patio.component';
import { LaudosEditadosComponent } from './relatorios/laudos-editados/laudos-editados.component';
import { HistoricoVeiculoComponent } from './relatorios/historico-veiculo/historico-veiculo.component';
import { LaudosExcluidosCanceladosComponent } from './relatorios/laudos-excluidos-cancelados/laudos-excluidos-cancelados.component';
import { RelatorioTerminalComponent } from './relatorios/relatorio-terminal/relatorio-terminal.component';
import { RelatorioLaudoServicoComponent } from './relatorios/relatorio-laudo-servico/relatorio-laudo-servico.component';
import { RelatorioFinanceiroPatioComponent } from './relatorios/relatorio-financeiro-patio/relatorio-financeiro-patio.component';
import { ConsultaPosicaoPatioComponent } from './posicao-patio/consulta-posicao-patio/consulta-posicao-patio.component';
import { ListagemFilaDestinatarioComponent } from './parametrizacao/fila-destinatario/listagem-fila-destinatario/listagem-fila-destinatario.component';
import { ToleranciaParametrizacaoComponent } from './parametrizacao/tolerancia/tolerancia-parametrizacao.component';
import { NotificacoesParametrizacaoComponent } from './parametrizacao/notificacoes/notificacoes-parametrizacao.component';
import { ListagemJanelaComponent } from './parametrizacao/janela/listagem-janela/listagem-janela.component';
import { RelatorioPdfGenericComponent } from './relatorios/relatorio-pdf-generic/relatorio-pdf-generic.component';
import { RelatoriosGeraisComponent } from './relatorios/relatorios-gerais/relatorios-gerais.component';
import { DashboardServicosComponent } from './relatorios/dashboard-servicos/dashboard-servicos.component';
import { DashboardPatioComponent } from './relatorios/dashboard-patio/dashboard-patio.component';
import { DashboardFinanceiroComponent } from './relatorios/dashboard-financeiro/dashboard-financeiro.component';
import { ListagemProdutoComponent } from './estoque/produtos/listagem-produto/listagem-produto.component';
import { CadastroProdutoComponent } from './estoque/produtos/cadastro-produto/cadastro-produto.component';
import { ListagemEstoqueComponent } from './estoque/listagem-estoque/listagem-estoque.component';
import { CadastroEntradaEstoqueComponent } from './estoque/entrada-estoque/cadastro-entrada-estoque/cadastro-entrada-estoque.component';
import { CadastroSaidaEstoqueComponent } from './estoque/saida-estoque/cadastro-saida-estoque/cadastro-saida-estoque.component';
import { ListagemInventarioComponent } from './estoque/inventario/listagem-inventario/listagem-inventario.component';
import { ListagemMovimentacoesEstoqueComponent } from './estoque/movimentacoes/listagem-movimentacoes-estoque/listagem-movimentacoes-estoque.component';
import { CadastroAjusteEstoqueComponent } from './estoque/ajuste/cadastro-ajuste-estoque/cadastro-ajuste-estoque.component';
import { DashboardEstoqueComponent } from './estoque/dashboard-estoque/dashboard-estoque.component';
import { RelatorioEstoqueComponent } from './estoque/relatorios/relatorio-estoque/relatorio-estoque.component';
import { RelatorioEstoqueVendasComponent } from './estoque/relatorios/relatorio-estoque-vendas/relatorio-estoque-vendas.component';
import { RelatorioEstoqueMovimentacoesComponent } from './estoque/relatorios/relatorio-estoque-movimentacoes/relatorio-estoque-movimentacoes.component';
import { RelatorioEstoquePosicaoComponent } from './estoque/relatorios/relatorio-estoque-posicao/relatorio-estoque-posicao.component';
import { ListagemCaixaEstoqueComponent } from './caixa/listagem-caixa-estoque/listagem-caixa-estoque.component';
import { ModalVendaEstoqueComponent } from './caixa/modal-venda-estoque/modal-venda-estoque.component';

@NgModule({
  declarations: [
    ListagemAgendamentoComponent,
    CadastroFuncionarioComponent,
    ListagemFuncionarioComponent,
    ListagemCaixaComponent,
    RelatorioPlacasCaixaComponent,
    RelatorioClientesCaixaComponent,
    RelatorioVendasPorProdutoComponent,
    ModalAberturaCaixaComponent,
    ModalAcessoRestritoCaixaComponent,
    ModalRelatoriosMensaisCaixaComponent,
    ModalFechamentoCaixaComponent,
    ModalSangriaCaixaComponent,
    ModalSuprimentosCaixaComponent,
    ModalPagamentoCaixaComponent,
    CadastroDesengateComponent,
    ListagemDesengatesComponent,
    ListagemEmpresaComponent,
    TransferenciaEmpresaComponent,
    CadastroEngateComponent,
    ListagemEngatesComponent,
    ModalAutorizacaoComponent,
    ModalSelecaoDesengateComponent,
    CadastroEntradaComponent,
    CadastroAgendamentoComponent,
    ListagemEntradaGateComponent,
    ModalAlteracaoEntradaComponent,
    CadastroEntradaEstacionamentoTpgComponent,
    CadastroSaidaEstacionamentoTpgComponent,
    ListagemEstacionamentoTpgComponent,
    HomeComponent,
    LoginComponent,
    ListagemParametrizacaoComponent,
    CadastroPrecificacaoComponent,
    ListagemPrecificacaoComponent,
    CadastroServicoComponent,
    ListagemServicoComponent,
    EmailSenhaComponent,
    EsqueciSenhaComponent,
    CadastroSaidaGateComponent,
    ListagemSaidaGateComponent,
    ModalAcessoRestritoComponent,
    ModalEmpresasFaturadasComponent,
    ModalPagamentoSaidaComponent,
    CadastroEntradaServicosComponent,
    ListagemServicosComponent,
    CadastroLaudoHigienizacaoComponent,
    ListagemLaudosHigienizacaoComponent,
    CadastroParametrizacaoAcessosComponent,
    ModalCadastrarPerfilComponent,
    ListagemOrdemServicoComponent,
    ListagemLogsComponent,
    CadastroHigienizacaoAgendadaComponent,
    ListagemHigienizacaoAgendadaComponent,
    ListagemMotoristasComponent,
    VisualizacaoMotoristaComponent,
    ModalVincularCavaloCarretaComponent,
    NotFoundComponent,
    ListagemBlacklistComponent,
    FormBlacklistComponent,
    PatioFormModalComponent,
    TipoTurnoPipe,
    QuantidadeVeiculosPatioComponent,
    LaudosEditadosComponent,
    HistoricoVeiculoComponent,
    LaudosExcluidosCanceladosComponent,
    RelatorioLaudoServicoComponent,
    RelatorioFinanceiroPatioComponent,
    ListagemTransportadoraComponent,
    CadastroTransportadoraComponent,
    ConsultaPosicaoPatioComponent,
    ListagemFilaDestinatarioComponent,
    ToleranciaParametrizacaoComponent,
    NotificacoesParametrizacaoComponent,
    ListagemJanelaComponent,
    RelatorioTerminalComponent,
    RelatorioPdfGenericComponent,
    RelatoriosGeraisComponent,
    DashboardServicosComponent,
    DashboardPatioComponent,
    DashboardFinanceiroComponent,
    ListagemProdutoComponent,
    CadastroProdutoComponent,
    ListagemEstoqueComponent,
    CadastroEntradaEstoqueComponent,
    CadastroSaidaEstoqueComponent,
    ListagemInventarioComponent,
    ListagemMovimentacoesEstoqueComponent,
    CadastroAjusteEstoqueComponent,
    DashboardEstoqueComponent,
    RelatorioEstoqueComponent,
    RelatorioEstoqueVendasComponent,
    RelatorioEstoqueMovimentacoesComponent,
    RelatorioEstoquePosicaoComponent,
    ListagemCaixaEstoqueComponent,
    ModalVendaEstoqueComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PdfViewerModule,
    IconsModule,
    CountdownModule,
    ComponentsModule,
    MatTooltipModule
],
  exports: [
    ListagemAgendamentoComponent,
    CadastroFuncionarioComponent,
    ListagemFuncionarioComponent,
    ListagemCaixaComponent,
    RelatorioPlacasCaixaComponent,
    RelatorioClientesCaixaComponent,
    RelatorioVendasPorProdutoComponent,
    ModalAberturaCaixaComponent,
    ModalAcessoRestritoCaixaComponent,
    ModalFechamentoCaixaComponent,
    ModalRelatoriosMensaisCaixaComponent,
    ModalSangriaCaixaComponent,
    ModalSuprimentosCaixaComponent,
    ModalPagamentoCaixaComponent,
    CadastroDesengateComponent,
    ListagemDesengatesComponent,
    ListagemEmpresaComponent,
    TransferenciaEmpresaComponent,
    CadastroEngateComponent,
    ListagemEngatesComponent,
    ModalAutorizacaoComponent,
    ModalSelecaoDesengateComponent,
    CadastroEntradaComponent,
    CadastroAgendamentoComponent,
    ListagemEntradaGateComponent,
    ModalAlteracaoEntradaComponent,
    CadastroEntradaEstacionamentoTpgComponent,
    CadastroSaidaEstacionamentoTpgComponent,
    ListagemEstacionamentoTpgComponent,
    HomeComponent,
    LoginComponent,
    ListagemParametrizacaoComponent,
    CadastroServicoComponent,
    ListagemServicoComponent,
    EmailSenhaComponent,
    EsqueciSenhaComponent,
    CadastroSaidaGateComponent,
    ListagemSaidaGateComponent,
    ModalAcessoRestritoComponent,
    ModalEmpresasFaturadasComponent,
    ModalPagamentoSaidaComponent,
    CadastroEntradaServicosComponent,
    ListagemServicosComponent,
    CadastroLaudoHigienizacaoComponent,
    ListagemLaudosHigienizacaoComponent,
    CadastroParametrizacaoAcessosComponent,
    ModalCadastrarPerfilComponent,
    ListagemOrdemServicoComponent,
    ListagemLogsComponent,
    CadastroHigienizacaoAgendadaComponent,
    ListagemHigienizacaoAgendadaComponent,
    ListagemMotoristasComponent,
    VisualizacaoMotoristaComponent,
    ModalVincularCavaloCarretaComponent,
    NotFoundComponent,
    QuantidadeVeiculosPatioComponent,
    LaudosEditadosComponent,
    HistoricoVeiculoComponent,
    LaudosExcluidosCanceladosComponent,
    RelatorioLaudoServicoComponent,
    RelatorioFinanceiroPatioComponent,
    ListagemTransportadoraComponent,
    CadastroTransportadoraComponent,
    ConsultaPosicaoPatioComponent,
    ListagemFilaDestinatarioComponent,
    ToleranciaParametrizacaoComponent,
    ListagemJanelaComponent,
    RelatorioTerminalComponent,
    RelatorioPdfGenericComponent,
    RelatoriosGeraisComponent,
    DashboardServicosComponent,
    DashboardPatioComponent,
    DashboardFinanceiroComponent,
    ListagemProdutoComponent,
    CadastroProdutoComponent,
    ListagemEstoqueComponent,
    CadastroEntradaEstoqueComponent,
    CadastroSaidaEstoqueComponent,
    ListagemInventarioComponent,
    ListagemMovimentacoesEstoqueComponent,
    CadastroAjusteEstoqueComponent,
    DashboardEstoqueComponent,
    RelatorioEstoqueComponent,
    RelatorioEstoqueVendasComponent,
    RelatorioEstoqueMovimentacoesComponent,
    RelatorioEstoquePosicaoComponent,
    ListagemCaixaEstoqueComponent,
    ModalVendaEstoqueComponent
  ],
})
export class PagesModule {}
